import { ArrowForwardIosSharp } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import React, { ReactNode } from "react";

const BillCollapse = ({
  children,
  summary
}: {
  children?: ReactNode;
  summary: React.JSX.Element;
}): React.JSX.Element => {
  const [isOpen, setIsOpen] = React.useState<boolean>(false);
  return (
    <Accordion sx={{ width: "100%" }} expanded={isOpen} onChange={() => setIsOpen((prev) => !prev)}>
      <AccordionSummary
        id="panel 1"
        expandIcon={
          isOpen ? <ArrowForwardIosSharp sx={{ rotate: "-90deg" }} /> : <ArrowForwardIosSharp />
        }
      >
        {summary}
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
};

export default BillCollapse;
